<template>
  <div class="chart-box">
    <el-row :gutter="20" style="margin: 30px 0;">
      <el-col :span="6">
        <centerLeft defultIndex="1-2" />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>成果明细</el-breadcrumb-item>
          </el-breadcrumb>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>我的成果明细</span>
            </div>
            <el-card class="box-card" style="margin-bottom: 20px;" shadow="never">
              <el-form ref="form" :model="searchForm" class="department-form" size="medium">
                <div class="el-form-item" style="width: 600px;">
                  <el-input
                    placeholder="请输入内容"
                    v-model="searchForm.search"
                    class="input-with-select"
                  >
                    <el-select
                      v-model="searchForm.state"
                      class="first-select"
                      slot="prepend"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in typeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-button slot="append" @click="searchData" plain icon="el-icon-search">检索</el-button>
                  </el-input>
                </div>
              </el-form>
            </el-card>
            <el-card class="box-card" shadow="never">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="title" label="名称" min-width="300px"></el-table-column>
                <el-table-column prop="showPublish" label="创建时间" width="180"></el-table-column>
                <el-table-column prop="state" label="状态" :formatter="formatState"></el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.state===0"
                      @click="claimCick(scope.row.baseType,scope.row.baseId,scope.row.vipFlag)"
                      size="small"
                    >认领</el-button>
                    <el-button
                      v-else-if="scope.row.state===1"
                      @click="handleClaim(scope.row)"
                      size="small"
                    >编辑</el-button>
                    <el-button
                      v-else-if="scope.row.state===10"
                      @click="handleClaim(scope.row)"
                      size="small"
                    >再次申请报销</el-button>
                    <el-button
                      v-else-if="scope.row.state===4"
                      @click="handleClaim(scope.row)"
                      size="small"
                    >再次申请报销</el-button>
                    <el-button v-else @click="handleView(scope.row)" size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
                :page-size="pageSizes"
                @current-change="currentChange"
                style="text-align: right"
              ></el-pagination>
            </el-card>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'claim',
  components: {
    centerLeft,
  },
  data() {
    return {
      activeName: 'second',
      isRouter: true,
      total: 0,
      currentPage: 1,
      pageSizes: 10,
      typeOptions: [
        {
          value: '0',
          label: '待认领',
        },
        {
          value: '1',
          label: '待提交',
        },
        {
          value: '2',
          label: '待审核',
        },
        {
          value: '3',
          label: '审核中',
        },
        {
          value: '4',
          label: '不通过',
        },
        {
          value: '5',
          label: '已审核',
        },
        {
          value: '6',
          label: '不审核',
        },
        {
          value: '7',
          label: '等待报销',
        },
        {
          value: '8',
          label: '正在报销',
        },
        {
          value: '9',
          label: '报销成功',
        },
        {
          value: '10',
          label: '报销失败',
        },
      ],
      searchForm: {
        search: '',
        state: '',
        pageNo: 1,
      },
      tableData: [],
      userId: '',
    }
  },
  methods: {
    currentChange(val) {
      this.searchForm.pageNo = val
      this.searchData()
    },
    formatState(row) {
      console.log(row)
      if (row.state === 0) {
        return '待认领'
      } else if (row.state === 1) {
        return '待提交'
      } else if (row.state === 2) {
        return '待审核'
      } else if (row.state === 3) {
        return '审核中'
      } else if (row.state === 4) {
        return '不通过'
      } else if (row.state === 5) {
        return '已审核'
      } else if (row.state === 6) {
        return '不审核'
      } else if (row.state === 7) {
        return '等待报销'
      } else if (row.state === 8) {
        return '正在报销'
      } else if (row.state === 9) {
        return '报销成功'
      } else if (row.state === 10) {
        return '报销失败'
      } else {
        return '其他'
      }
    },
    searchData() {
      let currThis = this
      let data = this.searchForm
      axios({
        method: 'get',
        url:
          '/api/member/queryAllData?pageNo=' +
          data.pageNo +
          '&claimUserId=' +
          this.userId +
          '&search=' +
          data.search +
          '&beginTime=' +
          data.beginTime +
          '&endTime=' +
          data.endTime +
          '&searchType=' +
          data.searchType +
          '&state=' +
          data.state,
      })
        .then(function (response) {
          console.log(response)
          currThis.total = response.data.pageTotal
          currThis.tableData = response.data.list
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    claimCick(val1, val2, val3) {
      if (val1 == 'irBooks') {
        //window.location.href = "/front/member/books/initAdd/21/" + val2;
      } else if (val1 == 'irScientifictask') {
        //window.location.href = "/front/member/scientifictask/initAdd/21/" + val2;
      } else if (val1 == 'irDegreeDiss') {
        //window.location.href = "/front/member/degree/initAdd/21/" + val2;
      } else if (val1 == 'irForeginDiss') {
        this.$router.push({
          path: '/center/foreign',
          query: { id: val2 },
        })
      } else if (val1 == 'irJournalDiss') {
        this.$router.push({
          path: '/center/china',
          query: { id: val2 },
        })
      } else if (val1 == 'irMeetingDiss') {
        //window.location.href = "/front/member/meeting/initAdd/21/" + val2;
      } else if (val1 == 'irPatent') {
        //window.location.href = "/front/member/patent/initAdd/21/" + val2;
      } else {
        //window.location.href = "/front/member/others/initAdd/21/" + val2;
      }
    },
    handleView(row) {
      console.log(row)
      this.$router.push({
        path: '/center/view',
        query: { id: row.baseId },
      })
    },
  },
  mounted() {
    this.userId = this.$cookies.get('rtnVal')
    this.searchData()
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/result.vue